import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BuildingListComponent } from './building-list.component';
import { SharedLayoutModule } from 'src/app/shared-layout/shared-layout.module';
import { BuildingItemComponent } from './building-item/building-item.component';
import { SortByModule } from 'src/app/libs/ui/pipes/sort-by/sort-by.module';
import { WithTooltipModule } from 'src/app/shared-layout/Components/with-tooltip/with-tooltip.module';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [BuildingListComponent, BuildingItemComponent],
  imports: [CommonModule, SharedLayoutModule, SortByModule, WithTooltipModule, TranslateModule],
  exports: [BuildingListComponent],
  providers: [
    LocalizationService,
    TranslateModule
  ],

})
export class BuildingListModule {}
